import React from 'react';

var Sidebar = function Sidebar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("aside", {
    className: "blog-sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      className: "blog-sidebar-group"
    }, child);
  })));
};

Sidebar.displayName = 'Sidebar';
var SidebarDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  SidebarDoc = require('./doc').doc(Sidebar);
}

var SidebarWrapper = SidebarDoc || Sidebar;
export { SidebarWrapper as Sidebar };